export const PLAN_STATE_UPDATED_EVENT = "nyafaz:plan-state-updated";

const normalize = (value) => String(value || "").trim().toLowerCase();

const toTitleCase = (value) => {
  const text = String(value || "").trim();
  if (!text) return "Free";

  return text
    .split(/[_\s-]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(" ");
};

export const buildPlanSnapshot = ({ planName, planStatus }) => {
  const normalizedPlan = normalize(planName);
  const normalizedStatus = normalize(planStatus) || "active";
  const formattedPlan = toTitleCase(normalizedPlan);

  return {
    plan: normalizedPlan,
    planStatus: normalizedStatus,
    displayPlanLabel:
      normalizedStatus === "trial_active"
        ? `Trial - ${formattedPlan}`
        : `${formattedPlan} Plan`,
  };
};

export const isResolvedPlanStatus = (planStatus) => {
  const normalizedStatus = normalize(planStatus);
  return normalizedStatus === "active" || normalizedStatus === "trial_active";
};

export const getPlanSnapshotFromPlanState = (planState) => {
  const activePlan = planState?.active_plan || null;
  const pendingPlan = planState?.pending_plan || null;
  const selectedPlan = activePlan || pendingPlan;
  const state = normalize(planState?.state);
  const paymentStatus = normalize(planState?.payment_status);
  const pendingStatus = normalize(pendingPlan?.status);
  const activeStatus = normalize(activePlan?.status);

  let planStatus = "active";

  if (
    state === "payment_pending_activation" ||
    paymentStatus === "pending" ||
    ["pending", "created", "authenticated"].includes(pendingStatus)
  ) {
    planStatus = "pending";
  } else if (
    ["cancelled", "halted", "paused"].includes(activeStatus) &&
    planState?.cancel_at_period_end
  ) {
    planStatus = "active";
  }

  if (!selectedPlan?.plan_name) {
    return null;
  }

  return buildPlanSnapshot({
    planName: selectedPlan.plan_name,
    planStatus,
  });
};

export const getPlanSnapshotFromSubscription = (subscription) => {
  const planName = subscription?.plan_name || subscription?.billing_name;
  const subscriptionStatus = normalize(subscription?.status);

  if (!planName) {
    return null;
  }

  let planStatus = "active";

  if (["trialing", "trial_active"].includes(subscriptionStatus)) {
    planStatus = "trial_active";
  } else if (["pending", "created", "authenticated"].includes(subscriptionStatus)) {
    planStatus = "pending";
  }

  return buildPlanSnapshot({
    planName,
    planStatus,
  });
};

export const persistPlanSnapshot = (snapshot) => {
  if (!snapshot?.plan) return;

  localStorage.setItem("plan", snapshot.plan);
  localStorage.setItem("plan_status", snapshot.planStatus || "active");
};

export const publishPlanSnapshot = (snapshot) => {
  if (!snapshot) return;

  persistPlanSnapshot(snapshot);
  window.dispatchEvent(
    new CustomEvent(PLAN_STATE_UPDATED_EVENT, {
      detail: snapshot,
    })
  );
};